export default __webpack_public_path__ + "static/media/pageRightPolygon.891d4780.svg";